// Page d'accueil selon le rôle — une seule règle pour la connexion, la racine « / » et le bouton
// « Retour » de l'écran « Accès non autorisé ». Elle ne renvoie jamais vers une page fermée au
// rôle (correctif du 4 octobre 2026 : l'agent IPM tombait sur /dashboard, qui lui est refusé, et
// le bouton « Retour » le renvoyait au même refus).
// Module JavaScript pur (sans JSX) : testé par la suite backend (accueil-agents.test.js).
// 4 octobre 2026 (mission SOGAS-RH-IPM-COMPLET-R1) : un prestataire externe de l'IPM (nature
// 'EXTERNE') n'a accès qu'à l'IPM ; sa page d'accueil est toujours /ipm.

// Rôles autorisés sur /dashboard (l'administrateur et la direction y accèdent par ailleurs).
export const ROLES_TABLEAU_DE_BORD = [
  'directeur_general', 'directeur_adjoint', 'drh',
  'rh_principal', 'assistant_rh', 'comptable',
  'prepose_regional', 'responsable_site',
  'chef_departement', 'chef_service', 'chef_equipe',
];

// Habilitations IPM (socle du 3 octobre 2026) : attribuées explicitement, jamais par le rôle.
// ipm_gestion, ipm_supervision et ipm_donnees_medicales viennent de la fonction IPM nominative
// (Agent / Gestionnaire IPM) ; les contrôles viennent du poste.
export const HABILITATIONS_IPM = [
  'ipm_gestion', 'ipm_supervision', 'ipm_controle_rh', 'ipm_controle_paie',
  'ipm_controle_financier', 'ipm_commission', 'ipm_donnees_medicales',
];

/** Prestataire externe de l'IPM (jamais salarié) : son compte n'ouvre que l'IPM. */
export const estExterne = (employe) => !!employe && employe.nature === 'EXTERNE';

export const aAccesIpm = (employe) => {
  const p = (employe && employe.permissions_effectives) || {};
  return HABILITATIONS_IPM.some((k) => p[k] === true);
};

export function pageAccueil(employe) {
  if (!employe) return '/login';
  if (estExterne(employe)) return '/ipm';
  const { role } = employe;
  if (role === 'employe' || role === 'journalier') return '/accueil-employe';
  if (role === 'admin' || ROLES_TABLEAU_DE_BORD.includes(role)) return '/dashboard';
  if (aAccesIpm(employe)) return '/ipm';
  // Agents IPM et œuvres sociales sans tableau de bord : leur page de travail.
  if (role === 'agent_ipm' || role === 'agent_oeuvre_sociale') return '/dettes';
  return '/dashboard';
}
